import { ConfirmationModal, type IConfirmationModalProps } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export interface IDuplicateExpenseReportConfirmationModalProps {
  open: boolean
  onConfirm: IConfirmationModalProps['onConfirm']
  onCancel: IConfirmationModalProps['handleDismiss']
}

export const DuplicateExpenseReportConfirmationModal = ({
  open,
  onConfirm,
  onCancel,
}: IDuplicateExpenseReportConfirmationModalProps) => {
  const intl = useProcurifyIntl()
  return (
    <ConfirmationModal
      open={open}
      onConfirm={onConfirm}
      handleDismiss={onCancel}
      header={intl.formatMessage(messages.title)}
      content={intl.formatMessage(messages.description)}
      confirmButtonText={intl.formatMessage(messages.confirmationButton)}
      cancelButtonText={intl.formatMessage(messages.cancelButton)}
      type='danger'
    />
  )
}
